import React, { useState, useEffect } from 'react';

export default function TextareaImage({ name, required, maxLength, preview, setPreview, setFile, setLength, advertiserId, postAsFollowupOption, value, onChange, onPostAsFollowupChange, metWith, setMetWith, metWithDefault, postAsFollowup }) {

    const pasteImage = (e) => {
        let file = e.clipboardData.files[0]
        if (file) {
            setPreview(URL.createObjectURL(file))
            setFile(file)
        }
    }

    const uploadImage = (e) => {
        e.preventDefault();
        let file = e.target.files[0]
        if (file) {
            setPreview(URL.createObjectURL(file))
            setFile(file)
        }
    }

    return (
        <>
            {
                preview &&
                <div className="position-relative">
                    <div className="position-absolute border rounded p-2 bg-white shadow" style={{ bottom: 15, right: 0 }}>
                        <img style={{ maxHeight: '50px' }} src={preview} alt="Uploaded File." />
                        <button className="btn btn-link" onClick={() => { setPreview(false); setFile(false) }}>Remove</button>
                    </div>
                </div>
            }
            {(metWithDefault ==true) && (
                <div className="form-group">
                    <label htmlFor="metWith">Met With</label>
                    <input type="text" className="form-control" id="metWith" name="metWith" value={metWith} onChange={(e)=>{
                        setMetWith(e.target.value)
                    }} />
                </div>
            )}
            <textarea 
                name={name} 
                required={required} 
                maxLength={maxLength} 
                onPaste={(e) => pasteImage(e)} 
                rows={4} 
                cols={40} 
                className="form-control" 
                placeholder="Notes (supports image pasting)." 
                value={value}
                onChange={(e) => {
                    onChange(e);
                    setLength(e.target.value.length);
                }} 
            />
            <div className="d-flex justify-content-between flex-row">
                <div>
                    <input type="file" onChange={(e) => uploadImage(e)} className="border rounded mt-2" accept="image/*, .csv, .xls, .xlsx, .pdf, .doc, .docx, .zip" />
                    <div className="text-secondary">File types: images, .csv, .xls, .xlsx, .pdf, .doc, .docx, .zip</div>
                </div>
                {postAsFollowupOption &&
                    <div>
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            id="postAsFollowup" 
                            checked={postAsFollowup} 
                            onChange={onPostAsFollowupChange}
                        />
                        <label className="form-check-label" htmlFor="postAsFollowup">Post{advertiserId > 0 ? ' to advertiser ' : ' as '}followup</label>
                    </div>
                }
            </div>
        </>
    )
}